// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---content-component-lifecycle-md": () => import("./../../../content/component-lifecycle.md" /* webpackChunkName: "component---content-component-lifecycle-md" */),
  "component---content-design-md": () => import("./../../../content/design.md" /* webpackChunkName: "component---content-design-md" */),
  "component---content-documentation-md": () => import("./../../../content/documentation.md" /* webpackChunkName: "component---content-documentation-md" */),
  "component---content-how-to-contribute-md": () => import("./../../../content/how-to-contribute.md" /* webpackChunkName: "component---content-how-to-contribute-md" */),
  "component---content-index-mdx": () => import("./../../../content/index.mdx" /* webpackChunkName: "component---content-index-mdx" */)
}

